var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup400(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.154)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#f4f7f2",
    transform: "translate(0 .154)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#486a41",
    d: "M56.1 20.383L62.929 10.3a1.853 1.853 0 0 0-.951-2.8L39.619.094a1.853 1.853 0 0 0-2.125.731l-5.87 8.805-5.87-8.805a1.853 1.853 0 0 0-2.125-.731L1.27 7.506a1.853 1.853 0 0 0-.951 2.8L7.15 20.383.319 30.461a1.853 1.853 0 0 0 .951 2.8l6.265 2.077v14.816A1.853 1.853 0 0 0 8.8 51.912l22.23 7.409a1.853 1.853 0 0 0 1.186 0l22.23-7.41a1.853 1.853 0 0 0 1.267-1.758V35.336l6.266-2.077a1.853 1.853 0 0 0 .951-2.8zM39.794 4.057l18.693 6.2-5.373 7.928-18.6-6.2zm-35.033 6.2l18.693-6.2 5.282 7.924-18.6 6.2zm0 20.259l5.373-7.928 18.6 6.2-5.282 7.924zm25.01 24.482l-18.53-6.177V36.565l12.388 4.106a1.853 1.853 0 0 0 2.125-.731l4.017-6.026zm1.853-29.153l-16.376-5.462 16.376-5.459L48 20.383zm20.383 22.973l-18.53 6.177v-21.08l4.017 6.026a1.853 1.853 0 0 0 2.125.731l12.388-4.106zM39.794 36.709l-5.283-7.924 18.6-6.2 5.373 7.928c-.316.105-18.139 6.012-18.69 6.196z",
    transform: "rotate(-7 421.87 -301.335)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup400);
export default __webpack_public_path__ + "static/media/Group 400.ffeffb1cc0dcb78abcfbc6ad1f118be0.svg";
export { ForwardRef as ReactComponent };